import Styles from '../../../../Styles';
import {Platform, StyleSheet, ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import RevolveNoBlockedUser from 'src/components/img/svg/revolveNoBlockedUser';
import Localized from 'src/constants/AppStrings';

export function getItemContainerStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    itemContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: Styles.Spacing.m3,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: Styles.lightGray,
    },
    blockedName: {
      fontFamily: Styles.FontFamily.robotoRegular,
      alignSelf: 'center',
      fontSize: Styles.Fonts.f1,
      flex: 1,
    },
    nocardsContainer: {
      width: 300,
      height: 450,
      marginVertical: 'auto',
      padding: 120,
      top: 70,
      ...(Platform.OS === 'web' && {
        alignSelf: 'center',
      }),
    },
  };
}

export function getUnBlockUserStyle(): {
  [index: string]: {[index: string]: number | string} | number | string;
} {
  return {
    btnUnblock: {},
    color: Styles.lightGray,
    btnUnblockContainer: {},
  };
}

export function getNoBlockedUsers(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    noCardsContainer: {},
  };
}

export function getBlockedUsersList(): {
  [index: string]: ViewStyle;
} {
  return {
    listWrapper: {
      paddingVertical: Styles.Spacing.m4,
      paddingHorizontal: Styles.Spacing.m3,
      backgroundColor: Styles.white,
      flex: 1,
    },
    listStyle: {
      flex: 1,
    },
    listShadow: getLayoutDescriber().shadowStyles().shadow,
  };
}

export function getBlockedUserTitle() {
  return Localized.Labels.blocked_users;
}

export function blockedUsersEmptyIcon(): JSX.Element {
  return <RevolveNoBlockedUser />;
}

export default {
  getItemContainerStyle,
  getUnBlockUserStyle,
  getBlockedUsersList,
  getBlockedUserTitle,
  blockedUsersEmptyIcon,
};
